import SelectInput, {SelectInputProps} from '@/components/refinedev/SelectInput';
import {InputProps} from '@/hooks/useInput';
import {useList} from '@refinedev/core';

export const JobSelectInput = (props: SelectInputProps) => {
  const jobList = useList({
    resource: 'jobs',
    sorters: [{field: 'title', order: 'asc'}],
    pagination: {current: 0, pageSize: 9999},
  });

  const choices = jobList.data?.data ? jobList.data.data : [];
  return <SelectInput choices={choices} optionText="title" emptyOptionText="<Tất cả>" {...props} />;
};
